
import HCLTreeMxStylesheet from "./HCLTreeMxStylesheet"; // refer to the actual source code

class FaultTreeMxStylesheet extends HCLTreeMxStylesheet {
  // createDefaultEdgeStyle(): Record<string, any> {
  //   const edgeStyle = super.createDefaultVertexStyle() as Record<string, any>;
  //   edgeStyle[MxGraph.mxConstants.STYLE_EDGE] = MxGraph.mxEdgeStyle.TopToBottom;
  //   edgeStyle[MxGraph.mxConstants.STYLE_STROKEWIDTH] = 2;
  //   edgeStyle[MxGraph.mxConstants.STYLE_STROKECOLOR] = 'rgba(86, 137, 156, 0.75)';
  //   edgeStyle.edgeStyle = MxGraph.mxConstants.EDGESTYLE_ELBOW;
  //   edgeStyle[MxGraph.mxConstants.STYLE_ELBOW] = MxGraph.mxConstants.ELBOW_VERTICAL;
  //   edgeStyle.endArrow = 'none';
  //   return edgeStyle;
  // }
}

export default FaultTreeMxStylesheet;
